import React, { useState } from 'react';
import ConfirmationModal from '../confirmationModal/ConfirmationModal';
import { Close } from '../../../../../static/icons/close';
import { Typography } from '../../../atoms/typography/Typography';

const ModalV2 = ({ children, header, onClose, t }) => {
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleClose = () => {
    setShowConfirmation((prev) => !prev);
  };

  const confirmClose = () => {
    setShowConfirmation(false);
    onClose();
  };

  return (
    <div className="fixed top-0 left-0 w-full h-full p-0 sm:px-5 sm:py-10 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative flex flex-col bg-white w-full h-full max-w-3xl sm:rounded-[40px] transition-opacity duration-500 opacity-100 pb-3">
        <button
          type="button"
          onClick={handleClose}
          aria-label="Close modal"
          className="absolute top-8 right-8 flex justify-center items-center w-12 h-12 border border-customGray-300 rounded-xl global-hover z-50"
        >
          <Close />
        </button>
        {React.cloneElement(children, {
          onClose,
          confirmClose,
        })}
        {header?.title && (
          <div className="absolute top-0 sm:-top-8 flex justify-center w-full h-16 bg-transparent">
            <div className="flex flex-row min-w-40 h-full px-3 gap-3 bg-white shadow-md rounded-[40px] justify-center items-center">
              <img
                className="w-[80px] h-[40px] rounded-full"
                src={header.imgUrl}
                alt={header.title}
              />
              <Typography
                fontVariant="md"
                className="w-fit leading-none font-normal pr-6"
              >
                {header.title}
              </Typography>
            </div>
          </div>
        )}
        {showConfirmation && (
          <ConfirmationModal
            isOpen={showConfirmation}
            onConfirm={confirmClose}
            onCancel={handleClose}
            message={t('formCommon.confirmClose')}
            t={t}
          />
        )}
      </div>
    </div>
  );
};

export default ModalV2;
